import { TBCTXKeys, TRESPONSE_ToBeRectifiedListing } from '@monorepo/types';
import { UiFilterModifiers } from '../../../ui-filter.modifier';
import { TFilterGroupModel } from '../../../ui-filter.types';

export const TO_BE_RECTIFIED_LISTING_FILTER_MODEL = {
  createModel: (
    items: TRESPONSE_ToBeRectifiedListing['selectedFilters'],
    prevModel?: TFilterGroupModel<TRESPONSE_ToBeRectifiedListing['selectedFilters'][number]>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: item.filterType,
        items: (item.values ? item.values : []).map((val) => {
          return {
            value: val,
            isSelected: false,
          };
        }),
        selectedValues: [],
      };
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
};
